import React from 'react';
import '../CSS/Profile/ManishProfile.css';

const ManishProfile: React.FC = () => {
  const imagePath = `${process.env.PUBLIC_URL || ''}/assets/Web Version/Team Page/Our Team/manish-mehta-image.png`;
  const linkedInIcon = `${process.env.PUBLIC_URL || ''}/assets/Web Version/Icons/linkedin-blue-icon.svg`;

  return (
    <div className="profile-page">
      <div className="profile-header">
        <div className="profile-picture-container">
          <img 
            src={imagePath}
            alt="Manish K Mehta"
            className="profile-picture"
          />
        </div>
      </div>
      <div className="profile-content">
        <h1 className="profile-name">Manish K Mehta</h1>
        <div className="profile-title-container">
          <p className="profile-title">Chairman</p>
          <a href="https://www.linkedin.com/in/mmehtas/" target="_blank" rel="noopener noreferrer">
            <img 
              src={linkedInIcon}
              alt="LinkedIn"
              className="profile-linkedin-icon"
            />
          </a>
        </div>
        <div className="profile-desc">
          <p>
            Strategic and innovative business leader, investor, and entrepreneur with over 30 years of experience. Expertise in applying technology to improve business performance products. Successful track record of driving growth by developing perceptive strategies and business models in the EdTech to FinTech to consumer. Proven abilities to lead innovative and transformative change. Capacity to turn around business profitability through operational improvement, product development, sales and marketing initiatives, and corporate finance transactions.
          </p>
          <p>
            Chairman, founder of multiple organizations, and a seasoned global leader. Experience in building and leading large global organizations at scale across multiple countries. Work in developing and leading learning and development programs for frontline to senior executives, university programs including internships, leadership development, and diversity programs. Responsible for recruiting, onboarding, and retaining diverse and bar-raising talent.
          </p>
          <p>
            Areas of specialization include startups, merger and acquisition strategies, go-to-market campaigns, new product development, data science, regulatory compliance, business intelligence, and supply chain. Comprehensive skill set that enables him to tackle complex business challenges and deliver exceptional results.
          </p>
          <p>
            Known for his multicultural background, outside-the-box thinking, and skill in strategy, risk management and international expansion.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ManishProfile;

